module.exports = __webpack_public_path__ + "images/exterior-restyling-77d6749a422cb0325e4338133d50bcb1.svg";